<template>
  <div>
    <v-expansion-panels
    :multiple="true"
    v-model="filterExpandArray"
    class="elevation-0 pa-0"
    flat
    >
      <v-expansion-panel
        v-for="(filter, index) in arrFilters"
        :key="index"
        class="wrld_background pa-0"
      >
        <v-expansion-panel-header
        class="pa-1"
        color="#FAFAFA"
        >
          <span
          class="filter--title"
          >{{ filter.title }}
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="pa-0" color="#FAFAFA">
          <div>
              <WrldSelectableFiltersInput
                v-show="filter.isSearchable !== undefined ? filter.isSearchable : true"
                @input="handleSearch.apply(null, [$event, filter.attribute, index])"
                @empty-input="handleEmptySearch.apply(null, [$event, filter.attribute, index])"
              />
              <span v-if="getFacetAvailableValues(filter.attribute) == null">{{ $t('orders.no_results') }}</span>
              <template>
                <v-checkbox
                  class="mt-1"
                  v-for="(item, index) in getFacetAvailableValues(filter.attribute)"
                  :key="`${item.value}_${index}`"
                  v-model="selectedValues"
                  :value="item.value"
                  @change="handleChecked.apply(null, [$event, item, filter.attribute, index])"
                  color="kazan"
                  hide-details
                >
                  <template v-slot:label>
                    <span
                      v-if="filter.colorMap"
                      class="coloredCircle"
                      :style="'background-color: ' + filter.colorMap[item.label]"
                    ></span>
                    <span v-if="filter.i18nPreffix">
                      {{ $t(filter.i18nPreffix + item.value) }}
                    </span>
                    <span v-else>
                      {{item.value}}
                    </span>
                    <v-chip
                      v-if="!filter.hideNumber"
                      color="secondary"
                      small
                      class="wrld_subtitle--text"
                    >
                    <span>
                      {{ item.count.toLocaleString() }}
                    </span>
                  </v-chip>
                  </template>
                </v-checkbox>
              </template>
            </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
import WrldSelectableFiltersInput from '@/components/wrld/filters/WrldSelectableFiltersInput'
  export default {
    name: 'WrldSelectableFiltersV2',
    components: {
      WrldSelectableFiltersInput
    },
    props: {
      arrFilters: Array,
      wrld: { type: Object, default: () => null },
    },
    data () {
      return {
        filterExpandArray: [],
        unsubscribe: null,
      }
    },
    methods: {
      ...mapActions({
        setFacetAttribute: 'refinementListFilters/setFacetAttribute',
        selectFacetValue: 'refinementListFilters/selectFacetValue',
        removeFacetValue: 'refinementListFilters/removeFacetValue',
        setFacetAttributeQuery: 'refinementListFilters/setFacetAttributeQuery'
      }),
      handleChecked(evt, item, attribute, index) {
        if (!this.getFacetValueIsSelected(attribute, item.value)) {
          this.selectFacetValue({ attribute, value: item.value })
        } else {
          this.removeFacetValue({ attribute, value: item.value })
        }
      },
      handleStoreSubscription() {
        if (this.unsubscribe === null) {
          this.unsubscribe = this.$store.subscribe((mutation, state) => {
            if (mutation.type === 'refinementListFilters/SET_FACET_SELECTED_VALUE') {
              this.handleOpenedFilters(mutation.payload.attribute)
            }
            if (mutation.type === 'refinementListFilters/REMOVE_FACET_SELECTED_VALUE') {
              this.handleOpenedFilters(mutation.payload.attribute)
            }
            if (mutation.type === 'numericsFilters/SET_NUMERICS_FROM') {
              this.handleOpenedFilters()
            }
            if (mutation.type === 'numericsFilters/SET_NUMERICS_TO') {
              this.handleOpenedFilters()
            }
            if (mutation.type === 'rangesFilters/SET_RANGE_FROM_TO') {
              this.handleOpenedFilters()
            }
          })
        }
      },
      handleOpenedFilters (attribute) {
        this.filterExpandArray.forEach((index) => {
          if (attribute !== this.arrFilters[index].attribute) {
            this.setFacetAttribute({
              index: this.wrld.facetIndex,
              attribute: this.arrFilters[index].attribute
            })
          }
        })
      },
      handleSearch (query, attribute) {
        if (query != null) {
          if (query.length > 0) {
            setTimeout(() => {
              this.setFacetAttributeQuery({
                query,
                index: this.wrld.facetIndex,
                attribute
              })
            }, 300)
          }
        }
      },
      handleEmptySearch (query, attribute) {
        setTimeout(() => {
          this.setFacetAttributeQuery({
            query: '',
            index: this.wrld.facetIndex,
            attribute
          })
        }, 300)
      }
    },
    computed: {
      ...mapGetters({
        getFacetAvailableValues: 'refinementListFilters/getFacetAvailableValues',
        getFacetValueIsSelected: 'refinementListFilters/getFacetValueIsSelected',
        getFacetAllSelectedValues: 'refinementListFilters/getFacetAllSelectedValues',
        getOpenFacets: 'refinementListFilters/getOpenFacets'
      }),
      selectedValues: {
        set (val) {
          console.log(val)
        },
        get () {
          return this.getFacetAllSelectedValues
        }
      }

    },
    watch: {
      filterExpandArray: {
        immediate: true,
        handler (val, oldVal) {
          const newlyOpened = val.filter((value) => {
            return oldVal.indexOf(value) < 0
          })
          newlyOpened.forEach((index) => {
            this.setFacetAttribute({
              index: this.wrld.facetIndex,
              attribute: this.arrFilters[index].attribute
            })
            this.handleStoreSubscription()
          })
        }
      },
      getOpenFacets: {
        immediate: true,
        handler (val) {
          val.forEach((key) => {
            const index = this.arrFilters.findIndex(({ attribute }) => (key === attribute))
            if (this.filterExpandArray.indexOf(index) < 0 && index >= 0) {
              this.filterExpandArray.push(index)
            }
          })
        }
      }
    },
    beforeDestroy() {
      if (this.unsubscribe != null) {
        this.unsubscribe()
      }
    },
  }
</script>

<style lang="scss" scoped>
  .filter--title {
    font-size: 13px;
    font-weight: 500;
  }
</style>
